export const heroLocale = {
  en: {
    radio_title: 'All',
    region_title: 'Class',
    market_title: 'Hero',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Hero',
    button_market: 'Hero',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '全部',
    region_title: '英雄职业',
    market_title: '英雄',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '英雄',
    button_market: '英雄',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const heroRadioOptions = [
  {
    value: 'global',
    text: 'All heros',
    textCN: '所有英雄',
  },
];
